import React from 'react';
import ReactDOM from 'react-dom';
import ReactGA from 'react-ga';
import { App } from './sections';
import CssBaseline from '@material-ui/core/CssBaseline';
import { ThemeProvider } from '@material-ui/core/styles';
import { theme } from './assets/theme';
import AOS from 'aos';
import 'aos/dist/aos.css';

ReactGA.initialize('G-C6Y6EKS1CH');
ReactGA.pageview(window.location.pathname + window.location.search);
AOS.init();

ReactDOM.render(
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <App />
  </ThemeProvider>,
  document.getElementById('root'),
);
